import axios from "axios";
import env from '../../config/env';

export const LOGIN_URL = env.login_url;
export const REGISTER_URL = "api/users/register";
export const REQUEST_PASSWORD_URL = "api/users/forgot-password";

export const ME_URL = env.me_url;

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}
